module.exports = __webpack_public_path__ + "img/questionnaire-purple.43c62ee2.svg";